import React, { useState, useEffect, createContext } from 'react';
import * as LDClient from 'launchdarkly-js-client-sdk';

import { TLaunchDarklyProps, TParams, TShowCases } from './types';

export const LaunchDarklyContext = createContext({} as TLaunchDarklyProps);

const LaunchDarklyProvider = ({ children }: TParams): JSX.Element | null => {
  const [baseURL, setBaseURL] = useState('');
  const [taxonomyURL, setTaxonomyURL] = useState('');
  const [gameURL, setGameURL] = useState('');

  const [isVisible, setVisible] = useState(false);

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const handleEnvironments = (ldclient: any) => {
    if (/localhost/.test(window.location.host)) {
      return {
        RECSYS_ENGINE_CONTROL: 'all' as TShowCases,
        RECSYS_ENGINE_API: 'https://recsys-engine-dev1.smiles.com.br',
        BASE_URL: 'https://apigw-dev1.smiles.com.br',
        GAME_URL: 'https://gamification-hml5.smiles.com.br',
      };
    }

    return ldclient.variation('api-data', false);
  };

  useEffect(() => {
    const user = { key: window.location.origin };

    const ldclient = LDClient.initialize('5dc03c40125008088b5cf13e', user, {
      baseUrl: 'https://ldrelay.smiles.com.br',
      sendEvents: false,
    });

    ldclient.on('ready', () => {
      const data = handleEnvironments(ldclient);
      const showcaseIsEnabled: TShowCases = data.RECSYS_ENGINE_CONTROL;

      if (showcaseIsEnabled !== 'none') {
        setBaseURL(`${data.RECSYS_ENGINE_API}/v2`);
        setTaxonomyURL(data.BASE_URL);
        setVisible(true);
        setGameURL(data.GAME_URL);
      }
    });
  }, []);

  if (isVisible) {
    return (
      <LaunchDarklyContext.Provider
        value={{
          baseURL,
          taxonomyURL,
          gameURL,
        }}
      >
        {children}
      </LaunchDarklyContext.Provider>
    );
  }

  return null;
};

export default LaunchDarklyProvider;
